import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAutocomplete,_vm._b({attrs:{"loading":_vm.loading,"items":_vm.values,"clearable":_vm.clearable,"auto-select-first":""},model:{value:(_vm.modified),callback:function ($$v) {_vm.modified=$$v},expression:"modified"}},'VAutocomplete',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }